// Role-based permissions configuration
export const ROLES = {
  ADMIN: 'ADMIN',
  BD: 'BD',
  COORDINATOR: 'COORDINATOR'
};

export const PERMISSIONS = {
  // Job permissions
  CREATE_JOB: 'CREATE_JOB',
  VIEW_JOB: 'VIEW_JOB',
  EDIT_JOB: 'EDIT_JOB',
  DELETE_JOB: 'DELETE_JOB',
  
  // Interview permissions
  SCHEDULE_INTERVIEW: 'SCHEDULE_INTERVIEW',
  VIEW_INTERVIEW: 'VIEW_INTERVIEW',
  EDIT_INTERVIEW: 'EDIT_INTERVIEW',
  DELETE_INTERVIEW: 'DELETE_INTERVIEW',
  ADD_FEEDBACK: 'ADD_FEEDBACK',
  
  // User permissions
  MANAGE_USERS: 'MANAGE_USERS',
  VIEW_ALL_JOBS: 'VIEW_ALL_JOBS',
  
  // Admin-only permissions
  MANAGE_BD: 'MANAGE_BD',
  MANAGE_INTERVIEW_TAKERS: 'MANAGE_INTERVIEW_TAKERS',
  VIEW_ALL_ANALYTICS: 'VIEW_ALL_ANALYTICS'
};

// Role-permission mapping
export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_JOB,
    PERMISSIONS.VIEW_JOB,
    PERMISSIONS.EDIT_JOB,
    PERMISSIONS.DELETE_JOB,
    PERMISSIONS.SCHEDULE_INTERVIEW,
    PERMISSIONS.VIEW_INTERVIEW,
    PERMISSIONS.EDIT_INTERVIEW,
    PERMISSIONS.DELETE_INTERVIEW,
    PERMISSIONS.ADD_FEEDBACK,
    PERMISSIONS.MANAGE_USERS,
    PERMISSIONS.MANAGE_BD,
    PERMISSIONS.MANAGE_INTERVIEW_TAKERS,
    PERMISSIONS.VIEW_ALL_ANALYTICS
  ],
  [ROLES.BD]: [
    PERMISSIONS.CREATE_JOB,
    PERMISSIONS.VIEW_JOB,
    PERMISSIONS.EDIT_JOB,
    PERMISSIONS.VIEW_INTERVIEW
  ],
  [ROLES.COORDINATOR]: [
    PERMISSIONS.CREATE_JOB,
    PERMISSIONS.VIEW_JOB,
    PERMISSIONS.EDIT_JOB,
    PERMISSIONS.DELETE_JOB,
    PERMISSIONS.SCHEDULE_INTERVIEW,
    PERMISSIONS.VIEW_INTERVIEW,
    PERMISSIONS.EDIT_INTERVIEW,
    PERMISSIONS.DELETE_INTERVIEW,
    PERMISSIONS.ADD_FEEDBACK,
    PERMISSIONS.VIEW_ALL_ANALYTICS
  ]
};

export const hasPermission = (userRole, permission) => {
  return ROLE_PERMISSIONS[userRole]?.includes(permission) || false;
};

export const canAccessRoute = (userRole, route) => {
  const routePermissions = {
    '/add-job': PERMISSIONS.CREATE_JOB,
    '/jobs': PERMISSIONS.VIEW_JOB,
    '/schedule': PERMISSIONS.SCHEDULE_INTERVIEW,
    '/manage-users': PERMISSIONS.MANAGE_USERS,
    '/manage-bd': PERMISSIONS.MANAGE_BD,
    '/manage-interview-takers': PERMISSIONS.MANAGE_INTERVIEW_TAKERS
  };
  
  return hasPermission(userRole, routePermissions[route]);
};

// Helper functions for role checks
export const isAdmin = (userRole) => userRole === ROLES.ADMIN;
export const isCoordinator = (userRole) => userRole === ROLES.COORDINATOR;
export const isBD = (userRole) => userRole === ROLES.BD;
export const canManageUsers = (userRole) => isAdmin(userRole);
export const canAddFeedback = (userRole) => isCoordinator(userRole) || isAdmin(userRole);
export const canScheduleInterview = (userRole) => isCoordinator(userRole);
export const canManageInterviewTakers = (userRole) => isAdmin(userRole);
export const canViewAnalytics = (userRole) => isCoordinator(userRole) || isAdmin(userRole);
export const canDeleteJobs = (userRole) => isCoordinator(userRole) || isAdmin(userRole);
export const canDeleteInterviews = (userRole) => isCoordinator(userRole) || isAdmin(userRole);